import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Divider, Tooltip, } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faPlus, faSync } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { message } from "antd";
import { useLocation } from 'react-router-dom';
import { setCreateSource, setLeadScope, setLeadListScope, updateLeadList } from '../../../Slices/salesSlice';
import { createLeadFilterThunk, fetchAllLeadFiltersByIDThunk, fetchLeadFiltersThunk, fetchLeads, fetchSalesCountsThunk } from "../../../Slices/salesSlice";
import { setIsRefetch, setRefreshStatus, } from "../../../Slices/salesSlice";
import { useLeadListKey, useLeadListField, useLeadListScope } from './useLeadList';

import SearchInput from './SearchInput';
import './Frames.scss'
import { InputField, SelectInput, AntdButton, DatePickerField } from '../../../blueplanitUtils/InputField';

// Must match MIN_PHONE_SEARCH_DIGITS in Backend/utility/phone.js.
const MIN_PHONE_FILTER_DIGITS = 3;

const SalesFilters = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  // Filters, sort, page, scope and panel state belong to THIS window's list only, so
  // two Leads windows can be filtered/searched independently.
  const { context, isPipeline, listKey } = useLeadListKey();
  const isRefetch = useSelector((state) => state.sales.isRefetch);
  const leadfilterObject = useLeadListField(listKey, "filters");
  const sortObject = useLeadListField(listKey, "sort");
  const page = useLeadListField(listKey, "page");
  const selectedFilterName = useLeadListField(listKey, "selectedFilterName");
  const prevVisibility = useLeadListField(listKey, "filterPanelOpen");
  const pendingReset = useLeadListField(listKey, "pendingReset");
  const allFilters = useSelector((state) => state?.sales?.savedFilters);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const userID = loginUser?.id;
  const leadScope = useLeadListScope(listKey, context);
  const updateList = (changes) => dispatch(updateLeadList({ key: listKey, changes }));

  const [agencySearchText, setAgencySearchText] = useState("");
  const [stateSearchText, setStateSearchText] = useState("");
  const [citySearchText, setCitySearchText] = useState("");
 
  
  const [isDisabled, setIsDisabled] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [saveDisable, setSaveDisable] = useState(true);
  const [filterAgencyName, setFilterAgencyName] = useState([]);
  const [filterState, setFilterState] = useState([]);
  const [filterCity, setFilterCity] = useState([]);
  const [leadfilterObjectTemp, setleadfilterObjectTemp] = useState({});
  const [saveFilterCheck, setSaveFilterCheck] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const salesFilters = useLeadListField(listKey, "leadFilters");

  const filterChannel = salesFilters?.channel?.filter(item => item?.trim() !== "");
  const filterAssignedTo = salesFilters?.assignedTo?.filter(item => item?.trim() !== "");
  const filterTimeZone = salesFilters?.timeZone?.filter(item => item.trim() !== "");
  const filterFollowup = salesFilters?.followup?.filter(item => item?.trim() !== "");
  const filterSuccessfull = salesFilters?.successfull?.filter(item => item?.trim() !== "");
  const filterStatus = salesFilters?.status?.filter(item => item?.trim() !== "");
  const filterPriority = salesFilters?.priority?.filter(item => item?.trim() !== "");
  const filterStage = salesFilters?.stage?.filter(item => item?.trim() !== "");
  const filterScheduledOPSStatus = salesFilters?.callscheduledwithOPs?.filter(item => item?.trim() !== "");
  const filterEmails = salesFilters?.contactEmail?.filter(item => item?.trim() !== "");

  // REMOVED (Rule 1 sync with Desktop): dispatch(setIsPipeline) was the cross-tab
  // corruption source. Nothing reads state.sales.isPipeline anymore — all consumers pass
  // isPipeline as an explicit param to thunks.

  useEffect(() => {
    if (userID) {
      dispatch(fetchAllLeadFiltersByIDThunk(userID));
    }
  }, [userID]);

  useEffect(() => {
    // Pass isPipeline explicitly (Rule 1 sync with Desktop fix for cross-tab corruption).
    dispatch(fetchLeads({ isPipeline, listKey }));
    dispatch(fetchSalesCountsThunk({ listKey }));
  }, [page, leadfilterObject, sortObject, isPipeline, leadScope, listKey]);

  useEffect(() => {
    dispatch(fetchLeadFiltersThunk({ listKey })).unwrap().catch((error) => {
      console.error('Failed to fetch lead filters:', error);
    });
  }, [leadfilterObject, isPipeline, leadScope, listKey]);

  useEffect(() => {
    const agencyName = salesFilters?.agencyName?.filter(item => item.trim() !== "") || [];
    const state = salesFilters?.state?.filter(item => item.trim() !== "") || [];
    const city = salesFilters?.city?.filter(item => item.trim() !== "") || [];

    setFilterAgencyName(agencyName);
    setFilterState(state);
    setFilterCity(city);
  }, [salesFilters]);

  useEffect(() => {
    if (Object.keys(leadfilterObjectTemp).length === 0 || Object.values(leadfilterObjectTemp).every(value => value === undefined || value === '')) {
      setSaveDisable(true)
    }
  }, [leadfilterObjectTemp]);

  useEffect(() => {
    setleadfilterObjectTemp(leadfilterObject);
    dispatch(setIsRefetch(false));
  }, [isRefetch]);

  // After a lead is created from THIS window, reset its filters (resetting changes the
  // filters/page, which refetches the list and filter options via the effects above).
  // Other windows are untouched — the new lead reaches them through updateSales.
  useEffect(() => {
    if (pendingReset) {
      updateList({ pendingReset: false });
      resetFilters();
    }
  }, [pendingReset]);

  useEffect(() => {
    const savedScope = localStorage.getItem(`leadScope_${context}`);

    if (savedScope) {
      dispatch(
        setLeadScope({
          context,
          scope: savedScope
        })
      );
    }
  }, [context, dispatch]);


  const handleFilters = (event) => {
    updateList({ filterPanelOpen: !prevVisibility });
    if (!prevVisibility && leadfilterObject) {
      setleadfilterObjectTemp(leadfilterObject);  // Store current filter object in temp
    } else if (!prevVisibility && leadfilterObjectTemp) {
      setleadfilterObjectTemp(leadfilterObjectTemp);
    }
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleCreateSale = () => {
    // Detect source based on current URL
    const pathname = location.pathname.toLowerCase();
    const source = pathname.startsWith("/sales") ? "sales" : "pipeline";

    // Store in Redux
    dispatch(setCreateSource(source));

    // Navigate to Create Sale page
    updateList({ createOpen: true });
  };


  // Also used directly as an onClick handler, so only read the explicit `resetSort` flag
  // from the argument (never spread it — it may be a click event).
  const resetFilters = (options) => {
    dispatch(setRefreshStatus(null))
    setClearSearch(true)
    updateList({
      filters: {}, selectedFilterName: "", page: 1,
      ...(options?.resetSort === true ? { sort: {} } : {}),
    });
    setleadfilterObjectTemp({})
    setSaveFilterCheck(false)

  }

  const handleCloseFilter = () => {
    updateList({ filterPanelOpen: false });
    setleadfilterObjectTemp(leadfilterObject)
  }

  const handleKeyDown = (e) => {
    let value = e.target.value.replace(/[^\d/]/g, ''); // Remove non-numeric and non-slash characters

    if (value.length >= 10 && e.key !== "Backspace") {
      e.preventDefault(); // Prevent typing more than 10 characters
      return;
    }

    value = value
      .replace(/^(\d{2})(\d)$/g, '$1/$2') // Add '/' after first two digits (DD/)
      .replace(/^(\d{2}\/\d{2})(\d{1,4})$/g, '$1/$2'); // Add '/' after month (DD/MM/YYYY)

    e.target.value = value;
  };

  const loadAgencyNames = (value) => {
    if (value.length > 2) {
      let allAgencyNames = salesFilters?.agencyName || [];
      const searchedAgencyNames = allAgencyNames.filter(str =>
        str.toLowerCase().includes(value.toLowerCase())
      );
      setFilterAgencyName(searchedAgencyNames);
    } else {
      setFilterAgencyName(salesFilters?.agencyName?.filter(item => item.trim() !== "") || []);
    }
  };

  const loadStates = (value) => {
    if (value.length > 2) {
      let allStates = salesFilters?.state || [];
      const searchedStates = allStates.filter(str =>
        str.toLowerCase().includes(value.toLowerCase())
      );
      setFilterState(searchedStates);
    } else {
      setFilterState(salesFilters?.state?.filter(item => item.trim() !== "") || []);
    }
  };

  const loadCities = (value) => {
    if (value.length > 2) {
      const searchedCities = salesFilters?.city?.filter(str =>
        str.toLowerCase().includes(value.toLowerCase())
      );
      setFilterCity(searchedCities);
    } else {
      setFilterCity(salesFilters?.city?.filter(item => item.trim() !== "") || []);
    }
  };

  const handleSavedFiltersChange = (filterName) => {
    // Find the selected filter object based on filterName
    dispatch(setRefreshStatus(null))
    const selectedFilter = allFilters.find((filter) => filter.filterName === filterName);

    if (selectedFilter) {
      try {
        const savedFilterObject = JSON.parse(selectedFilter.filterString);
        updateList({ filters: savedFilterObject, selectedFilterName: selectedFilter });
        setleadfilterObjectTemp(savedFilterObject)

      } catch (error) {
        console.error("Failed to parse filterString:", error);
        message.error("This saved filter could not be loaded.");
      }
    } else {
      updateList({ filters: {}, selectedFilterName: {} });
    }

    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleClear = () => {
    updateList({ filters: {}, selectedFilterName: "" });
    setleadfilterObjectTemp({})
    setSaveFilterCheck(false)
  };

  // S.NO is a number in the database — keep digits only.
  const handleFilterSnoChange = (event) => {
    const leadID = event.target.value.replace(/\D/g, '');
    setleadfilterObjectTemp((prvState) => ({ ...prvState, leadID }));
    setSaveFilterCheck(false)
    setFilterName('')

  };

  // Free text: matches contact phones regardless of formatting (backend ignores
  // spaces, dashes, brackets, dots and a leading +1). Only phone characters are kept.
  const handleFilterPhoneChange = (event) => {
    const phone = event.target.value.replace(/[^\d+\-().\s]/g, '');
    setleadfilterObjectTemp((prvState) => ({ ...prvState, phone }));
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleFilterAgencyChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, agencyName: value }));
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleFilterStateChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, state: value }));
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleFilterCityChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, city: value }));
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleFilterChannelChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, channel: value }));
    setSaveFilterCheck(false)
    setFilterName('')
  };

  const handleFilterAssignedToChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, assignedTo: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterTimezoneChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, timeZone: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterFollowUpChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, followup: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterSuccessfullChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, successfull: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterStageChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, stage: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterOPSCallChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, callscheduledwithOPs: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterStatusChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, status: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterPriorityChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, priority: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterEmailsChange = (value) => {
    setleadfilterObjectTemp((prvState) => ({ ...prvState, contactEmail: value }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  //updated
  const handleFilterLastUpdatedFromChange = (date) => {
    const formattedDate = date ? dayjs(date).startOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastUpdatedFrom: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterLastUpdatedToChange = (date) => {
    const formattedDate = date ? dayjs(date).endOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastUpdatedTo: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  // Repeat for Contacted & Follow-up:

  const handleFilterLastContactedFromChange = (date) => {
    const formattedDate = date ? dayjs(date).startOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastContactedFrom: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterLastContactedToChange = (date) => {
    const formattedDate = date ? dayjs(date).endOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastContactedTo: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterLastFollowupFromChange = (date) => {
    const formattedDate = date ? dayjs(date).startOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastFollowupFrom: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };

  const handleFilterLastFollowupToChange = (date) => {
    const formattedDate = date ? dayjs(date).endOf('day').toISOString() : null;
    setleadfilterObjectTemp((prev) => ({ ...prev, lastFollowupTo: formattedDate }));
    setSaveFilterCheck(false);
    setFilterName('');
  };


  const setFilters = () => {
    dispatch(setRefreshStatus(null))

    // Remove empty arrays from leadfilterObjectTemp
    Object.keys(leadfilterObjectTemp).forEach(key => {
      if (Array.isArray(leadfilterObjectTemp[key]) && leadfilterObjectTemp[key].length === 0) {
        delete leadfilterObjectTemp[key];
      }
    });

    if (
      !leadfilterObjectTemp ||
      Object.keys(leadfilterObjectTemp).length === 0 ||
      Object.values(leadfilterObjectTemp).every(value => value === undefined || value === '')
    ) {
      startTimer();
      message.error('Please enter filter criteria before applying.');
      return; // Exit if no criteria are provided
    }
    const phoneDigitCount = (leadfilterObjectTemp.phone || '').replace(/\D/g, '').length;
    if (leadfilterObjectTemp.phone && phoneDigitCount < MIN_PHONE_FILTER_DIGITS) {
      startTimer();
      message.error(`Enter at least ${MIN_PHONE_FILTER_DIGITS} digits to filter by phone number.`);
      return;
    }
    updateList({ filterPanelOpen: false, page: 1, filters: { ...leadfilterObjectTemp } });
    setSaveDisable(false)
  };

  const saveFilterCheckHandler = () => {
    // Check if leadfilterObject is empty
    if (!leadfilterObject || Object.keys(leadfilterObject).length === 0 || Object.values(leadfilterObjectTemp).every(value => value === undefined || value === '')) {
      message.error('Please enter filter criteria before saving.');
      return; // Exit the function if the object is empty
    }
    setSaveFilterCheck(!saveFilterCheck)
    setFilterName('')
  }

  const handlefilterNameChange = (e) => {
    setFilterName(e.target.value)
  }
  const handleSaveFilter = () => {

    const filterObject = {
      userID: userID,
      filterName: filterName,
      filterString: JSON.stringify(leadfilterObject),
      filterStatus: true,
    };

    // Check if filterName is also provided
    if (!filterName) {
      startBtnTimer();
      message.error('Please enter a name for the filter.');
      return;
    }

    // Check for duplicate filter name in allFilters
    const isDuplicate = allFilters.some(
      (filter) => filter.filterName.toLowerCase() === filterName.toLowerCase()
    );
    if (isDuplicate) {
      startBtnTimer();
      message.error({ content: "A filter with the same name already exists. Please choose a different name." });
      return;
    }

    dispatch(createLeadFilterThunk({ filterObject }));

    message.success({
      content: "Filter saved successfully!",
      duration: 5,
      className: 'custom-toast-center',
    });

    setFilterName('');
  };

  const handleOpen = () => {
    updateList({ createOpen: true });
  };


  const startTimer = () => {
    setIsDisabled(true); // Disable the button
    setTimeout(() => {
      setIsDisabled(false); // Enable the button after 5 seconds
    }, 3000);
  };

  const startBtnTimer = () => {
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Enable the button after 5 seconds
    }, 3000);
  };

  return (
    <div>
      <Form
        layout="inline"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <SelectInput
            value={leadScope}
            style={{ width: 180, }}
            onChange={(value) => {
              dispatch(setRefreshStatus(null))
              // Changes this window only; also remembered as the default for new windows.
              dispatch(setLeadListScope({ key: listKey, scope: value }));
              try {
                localStorage.setItem(`leadScope_${context}`, value);
              } catch {}
              updateList({ page: 1 });
            }}
            options={[
              { label: "My Leads", value: "MY" },
              { label: "All Leads", value: "ALL" },
            ]}
          />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip title="Sync Now">
            <FontAwesomeIcon
              icon={faSync}
              style={{
                fontSize: '24px',
                color: '#1890ff',
                cursor: 'pointer',
                marginRight: '7px',
                marginBottom: '15px',
              }}
              onClick={() => resetFilters({ resetSort: true })}
            />
          </Tooltip>
          <SearchInput
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            listKey={listKey}
          />
          <SelectInput
            options={allFilters?.map(option => ({ label: option?.filterName, value: option?.filterName }))}
            value={selectedFilterName?.filterName || undefined}
            onChange={handleSavedFiltersChange}
            showSearch
            allowClear
            className="custom-dropdown"
            onClear={handleClear}
            placeholder="Saved Filters"
            style={{ width: 200 }}
          />

          <AntdButton
            label="Filter"
            onClick={handleFilters}
            icon={<FontAwesomeIcon icon={faFilter} />}
            color="primary"
            variant="solid"
            style={{ marginBottom: "15px", color: 'white', }}
          />
          <AntdButton
            label="Create Sale"
            onClick={handleCreateSale}
            icon={<FontAwesomeIcon icon={faPlus} />} // Add a "+" icon
            color="primary"
            variant="solid"
            style={{ marginBottom: "15px", color: "white", marginRight: '20px' }}
          />
        </div>
      </Form>

      {prevVisibility && (
        <div>
          <div
            className="sales-card-container"
          >
            <AntdButton
              onClick={handleCloseFilter}
              style={{
                background: "none",
                border: "none",
                fontSize: "22px",
                color: "black",
                position: "absolute",
                top: "-5px",
                right: "-15px",
                cursor: "pointer",
              }}
              label="×"
            />
            <Form layout="vertical" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Row className="custom-scrollbar" gutter={[24, 0]} style={{ height: '73vh', overflow: 'auto', flex: 1, marginTop: '20px', marginBottom: '15px' }}>

                {/* ── LEAD ── */}
                <Col span={24}><Divider orientation="left" style={{ fontSize: 11, color: '#6b7280', margin: '4px 0 8px' }}>Lead</Divider></Col>
                <Col style={{ marginBottom: '10px' }} span={24}>
                  <InputField
                    label="S.NO"
                    placeholder="Enter S.no"
                    value={leadfilterObjectTemp?.leadID}
                    onChange={handleFilterSnoChange}
                    allowClear
                  />
                </Col>
                <Col style={{ marginBottom: '10px' }} span={24}>
                  <InputField
                    label="Phone Number"
                    placeholder="e.g. 302-555-1234 or 555"
                    value={leadfilterObjectTemp?.phone}
                    onChange={handleFilterPhoneChange}
                    allowClear
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    label="Agency Name"
                    value={leadfilterObjectTemp?.agencyName || []}
                    options={filterAgencyName?.map(name => ({ label: name.trim(), value: name.trim() }))}
                    onChange={handleFilterAgencyChange}

                    searchValue={agencySearchText}
                    onSearch={(value) => {
                      setAgencySearchText(value);
                      loadAgencyNames(value);
                    }}

                    onDropdownVisibleChange={(open) => {
                      if (!open) {
                        // ✅ reset search input
                        setAgencySearchText("");

                        // ✅ restore full list
                        setFilterAgencyName(
                          salesFilters?.agencyName?.filter(item => item.trim() !== "") || []
                        );
                      }
                    }}
                    autoClearSearchValue={false}
                    showSearch={true}
                    placeholder="Search Agency"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.status || []}
                    onChange={handleFilterStatusChange}
                    options={filterStatus?.map(status => ({ label: status, value: status }))}
                    placeholder="Select Status"
                    label="Lead Status"
                    allowClear
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.stage || []}
                    onChange={handleFilterStageChange}
                    options={filterStage?.map(stage => ({ label: stage, value: stage }))}
                    placeholder="Select Stage"
                    allowClear
                    label="Lead Stage"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.priority || []}
                    onChange={handleFilterPriorityChange}
                    options={filterPriority?.map(priority => ({ label: priority, value: priority }))}
                    placeholder="Select Priority"
                    allowClear
                    label="Priority"
                    style={{ width: '100%' }}
                  />
                </Col>

                {/* ── LOCATION ── */}
                <Col span={24}><Divider orientation="left" style={{ fontSize: 11, color: '#6b7280', margin: '12px 0 8px' }}>Location</Divider></Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    label="State"
                    value={leadfilterObjectTemp?.state || []}
                    options={filterState?.map(state => ({ label: state, value: state }))}
                    onChange={handleFilterStateChange}
                    searchValue={stateSearchText}
                    onSearch={(value) => {
                      setStateSearchText(value);
                      loadStates(value);
                    }}

                    onDropdownVisibleChange={(open) => {
                      if (!open) {
                        setStateSearchText("");
                        setFilterState(
                          salesFilters?.state?.filter(item => item.trim() !== "") || []
                        );
                      }
                    }}

                    autoClearSearchValue={false}
                    placeholder="Search State"
                    showSearch={true}
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    label="City"
                    value={leadfilterObjectTemp?.city || []}
                    options={filterCity?.map(city => ({ label: city, value: city }))}
                    onChange={handleFilterCityChange}
                    searchValue={citySearchText}
                    onSearch={(value) => {
                      setCitySearchText(value);
                      loadCities(value);
                    }}

                    onDropdownVisibleChange={(open) => {
                      if (!open) {
                        setCitySearchText("");
                        setFilterCity(
                          salesFilters?.city?.filter(item => item.trim() !== "") || []
                        );
                      }
                    }}

                    autoClearSearchValue={false}
                    showSearch={true}
                    placeholder="Search City"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.timeZone || []}
                    onChange={handleFilterTimezoneChange}
                    options={filterTimeZone?.map(zone => ({ label: zone, value: zone }))}
                    placeholder="Select Time Zone"
                    allowClear
                    label="Time Zone"
                    style={{ width: '100%' }}
                  />
                </Col>

                {/* ── ASSIGNMENT ── */}
                <Col span={24}><Divider orientation="left" style={{ fontSize: 11, color: '#6b7280', margin: '12px 0 8px' }}>Assignment</Divider></Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.assignedTo || []}
                    onChange={handleFilterAssignedToChange}
                    options={filterAssignedTo
                      ?.filter(person => person)
                      .map(person => ({ label: person, value: person }))
                    }
                    placeholder="Select Assigned to"
                    allowClear
                    label="Assigned To"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.channel || []}
                    onChange={handleFilterChannelChange}
                    options={filterChannel?.map(channel => ({ label: channel, value: channel }))}
                    placeholder="Select Channel"
                    allowClear
                    label="Channel"
                    style={{ width: '100%' }}
                  />
                </Col>

                {/* ── PIPELINE & FLAGS ── */}
                <Col span={24}><Divider orientation="left" style={{ fontSize: 11, color: '#6b7280', margin: '12px 0 8px' }}>Pipeline & Flags</Divider></Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    value={leadfilterObjectTemp?.followup}
                    onChange={handleFilterFollowUpChange}
                    options={filterFollowup?.map(followup => ({ label: followup, value: followup }))}
                    placeholder="Select Follow Up"
                    allowClear
                    label="Follow Up"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    value={leadfilterObjectTemp?.successfull}
                    onChange={handleFilterSuccessfullChange}
                    options={filterSuccessfull?.map(success => ({ label: success, value: success }))}
                    placeholder="Select Successful"
                    allowClear
                    label="Lead Successful"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    value={leadfilterObjectTemp?.callscheduledwithOPs}
                    onChange={handleFilterOPSCallChange}
                    options={filterScheduledOPSStatus?.map(status => ({ label: status !== "true" ? "False" : "True", value: status }))}
                    placeholder="Select Call with OPS"
                    allowClear
                    label="Call with OPS Status"
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <SelectInput
                    mode="multiple"
                    value={leadfilterObjectTemp?.contactEmail || []}
                    onChange={handleFilterEmailsChange}
                    options={filterEmails?.map(contactEmail => ({ label: contactEmail, value: contactEmail }))}
                    placeholder="Select Email"
                    allowClear
                    label="Email"
                    style={{ width: '100%' }}
                  />
                </Col>

                {/* ── DATES ── */}
                <Col span={24}><Divider orientation="left" style={{ fontSize: 11, color: '#6b7280', margin: '12px 0 8px' }}>Dates</Divider></Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Last Updated From"
                    value={leadfilterObjectTemp.lastUpdatedFrom ? dayjs(leadfilterObjectTemp.lastUpdatedFrom) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastUpdatedFromChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Last Updated To"
                    value={leadfilterObjectTemp.lastUpdatedTo ? dayjs(leadfilterObjectTemp.lastUpdatedTo) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastUpdatedToChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Last Contacted From"
                    value={leadfilterObjectTemp.lastContactedFrom ? dayjs(leadfilterObjectTemp.lastContactedFrom) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastContactedFromChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Last Contacted To"
                    value={leadfilterObjectTemp.lastContactedTo ? dayjs(leadfilterObjectTemp.lastContactedTo) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastContactedToChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Follow-up From"
                    value={leadfilterObjectTemp.lastFollowupFrom ? dayjs(leadfilterObjectTemp.lastFollowupFrom) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastFollowupFromChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>
                <Col style={{ marginBottom: '-10px' }} span={24}>
                  <DatePickerField
                    label="Follow-up To"
                    value={leadfilterObjectTemp.lastFollowupTo ? dayjs(leadfilterObjectTemp.lastFollowupTo) : null}
                    placeholder="DD/MM/YYYY"
                    onChange={handleFilterLastFollowupToChange}
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                  />
                </Col>

              </Row>

              <Row style={{ marginTop: 'auto' }}>
                <Col span={24}>
                  <div className="d-flex justify-content-center" style={{ gap: '5px' }}>
                    <AntdButton
                      label="Reset"
                      onClick={resetFilters}
                      icon={<FontAwesomeIcon icon={faSync} />}
                      type="default"
                      style={{ backgroundColor: '#837F7F', borderRadius: '20px', color: 'white', }}
                    />
                    <AntdButton
                      label="Apply"
                      onClick={setFilters}
                      color="primary"
                      variant="solid"
                      disabled={isDisabled}
                      style={{ borderRadius: '20px', }}
                    />
                    <AntdButton
                      label="Save"
                      onClick={saveFilterCheckHandler}
                      color="primary"
                      variant="solid"
                      disabled={saveDisable}
                      style={{ color: 'white', borderRadius: '20px', }}
                    />
                  </div>
                </Col>
              </Row>

              {saveFilterCheck && (
                <Row justify="center" style={{ textAlign: 'center' }}>
                  <Col span={24}>
                    <Divider style={{ borderColor: '#1890ff' }} />
                  </Col>
                  <Col span={24}>
                    <Col flex="auto" span={24}>
                      <InputField
                        name="filterName"
                        id="filterName"
                        value={filterName}
                        onChange={handlefilterNameChange}
                        autoFocus={!saveFilterCheck}
                        placeholder="Filter Name"
                        disabled={!saveFilterCheck}
                      />
                    </Col>
                    <Col span={24}>
                      <AntdButton
                        label="Save Filter"
                        disabled={!saveFilterCheck || disabled}
                        type="primary"
                        style={{
                          backgroundColor: disabled ? 'transparent' : '#0253cc',
                          borderRadius: '20px',
                          color: 'white',
                          marginTop: '15px'
                        }}
                        onClick={handleSaveFilter}
                      />
                    </Col>
                  </Col>
                </Row>
              )}
            </Form>
          </div>
        </div>
      )
      }
    </div>
  );
};

export default SalesFilters;